var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActiveUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_399_5440)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.66667 8.16266C9.69171 8.16266 11.3333 6.52104 11.3333 4.496C11.3333 2.47095 9.69171 0.82933 7.66667 0.82933C5.64162 0.82933 4 2.47095 4 4.496C4 6.52104 5.64162 8.16266 7.66667 8.16266Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.61634 14.504C7.92367 13.76 7.49967 12.7627 7.49967 11.6667C7.49967 10.5447 7.94434 9.52533 8.66701 8.776C8.34034 8.75067 8.00634 8.73734 7.66634 8.73734C5.45167 8.73734 3.49101 9.29134 2.27367 10.1213C1.34501 10.7547 0.833008 11.5593 0.833008 12.404V13.3707C0.833008 13.6713 0.952341 13.96 1.16501 14.172C1.37767 14.3847 1.66567 14.504 1.96634 14.504H8.61634Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.666 8.16666C9.73402 8.16666 8.16602 9.73466 8.16602 11.6667C8.16602 13.5987 9.73402 15.1667 11.666 15.1667C13.598 15.1667 15.166 13.5987 15.166 11.6667C15.166 9.73466 13.598 8.16666 11.666 8.16666ZM10.0553 12.2493L11.0553 12.916C11.2533 13.048 11.518 13.022 11.686 12.8533L13.3527 11.1867C13.548 10.992 13.548 10.6747 13.3527 10.48C13.158 10.2847 12.8407 10.2847 12.646 10.48L11.2687 11.8567L10.61 11.4173C10.3807 11.264 10.07 11.3267 9.91668 11.556C9.76335 11.7853 9.82602 12.096 10.0553 12.2493Z",
    fill: "currentcolor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_399_5440"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveUser);
export default __webpack_public_path__ + "static/media/active-user.40bf2a7cea67ecf5fb1b3b4072157535.svg";
export { ForwardRef as ReactComponent };